import { render, staticRenderFns } from "./VideoStats.vue?vue&type=template&id=1092994c&"
import script from "./VideoStats.vue?vue&type=script&lang=js&"
export * from "./VideoStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1092994c')) {
      api.createRecord('1092994c', component.options)
    } else {
      api.reload('1092994c', component.options)
    }
    module.hot.accept("./VideoStats.vue?vue&type=template&id=1092994c&", function () {
      api.rerender('1092994c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/Video/VideoStats.vue"
export default component.exports